import React, { useEffect, useState } from "react";
import apiClient from "../api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ForgotPassword = () => {
  const [results, setResults] = useState([]);
  const [passwordValues, setPasswordValues] = useState({}); // Track new password inputs
  const notify = () => toast("Password Updated Successfully!");

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await apiClient.post("user/forgot");
      const userInfo = response.data;
      setResults(userInfo);

      const initialPasswords = {};
      userInfo.forEach((user) => {
        initialPasswords[user.email] = ""; // Initialize input fields
      });
      setPasswordValues(initialPasswords);
    } catch (error) {
      console.error("No data Found", error);
    }
  };

  const handlePasswordChange = (email, value) => {
    setPasswordValues({
      ...passwordValues,
      [email]: value,
    });
  };

  const updatePassword = async (email) => {
    try {
      const response = await apiClient.post("user/updatepassword", {
        email,
        newPassword: passwordValues[email],
      });

      if (response) {
        notify();
        setPasswordValues({
          ...passwordValues,
          [email]: "", // Clear input after update
        });
      }
    } catch (error) {
      console.error("Something Went Wrong", error);
    }
  };

  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12">
            <h1 className="text-center mb-4">All Users</h1>
          </div>
        </div>
        <div className="table-responsive">
          {results.length > 0 ? (
            <table className="table table-bordered table-hover">
              <thead className="thead-dark">
                <tr>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Current Hashed Password</th>
                  <th>New Password</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {results.map((user) => (
                  <tr key={user._id}>
                    <td>{user.username}</td>
                    <td>{user.email}</td>
                    <td style={{ wordBreak: "break-all" }}>{user.password}</td>
                    <td>
                      <input
                        type="text"
                        placeholder="New Password"
                        value={passwordValues[user.email] || ""}
                        onChange={(e) =>
                          handlePasswordChange(user.email, e.target.value)
                        }
                        className="form-control"
                      />
                    </td>
                    <td>
                      <button
                        className="btn btn-primary"
                        onClick={() => updatePassword(user.email)}
                      >
                        Update
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No users available</p>
          )}
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ForgotPassword;
